import api from './api';

const fetcher = (url, queryParams = '') =>
  api.get(`${url}${queryParams}`).then((res) => res.data);

export default fetcher;
